module.exports = __webpack_public_path__ + "img/ok-sign.fbf8b18f.svg";